<template>
  <div class="pin-access-view">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" md="6" lg="4">
          <div class="text-center mb-6">
            <v-icon size="70" color="primary" class="gradient-icon mb-4"> mdi-key-variant </v-icon>
            <h1 class="text-h4 mb-3 text-primary font-weight-bold">Acceso con PIN</h1>
            <p class="text-body-1 text-black mt-2">
              Ingrese el código PIN proporcionado por su profesor
            </p>
          </div>

          <PinValidation
            @pin-validated="handlePinValidated"
            @access-granted="handleAccessGranted"
          />
        </v-col>
      </v-row>
    </v-container>

    <!-- Success snackbar -->
    <v-snackbar v-model="showSuccessMessage" color="success" timeout="4000" location="top right">
      <v-icon left>mdi-check-circle</v-icon>
      {{ successMessage }}
    </v-snackbar>

    <!-- Error snackbar -->
    <v-snackbar v-model="showErrorMessage" color="error" timeout="4000" location="top right">
      <v-icon left>mdi-alert-circle</v-icon>
      {{ errorMessage }}
    </v-snackbar>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import PinValidation from '@/components/pins/PinValidation.vue'

const store = useStore()

const showSuccessMessage = ref(false)
const successMessage = ref('')
const showErrorMessage = ref(false)
const errorMessage = ref('')

const handlePinValidated = (pinCode) => {
  successMessage.value = `PIN ${pinCode} validado correctamente`
  showSuccessMessage.value = true
}

const handleAccessGranted = (accessData) => {
  successMessage.value = `Acceso concedido al grupo: ${accessData.group_name}`
  showSuccessMessage.value = true
}

onMounted(() => {
  store.dispatch('pins/clearAccessData')
  store.dispatch('session/clearSession')
})
</script>

<style scoped>
.pin-access-view {
  min-height: 100vh;
  background-color: secondary;
  display: flex;
  align-items: center;
  padding: 2rem 0;
}

.v-container {
  position: relative;
  z-index: 1;
}

.pin-access-view::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.v-card {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.9) !important;
}

h1 {
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

p {
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.v-icon {
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.gradient-icon {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
}
</style>
